import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HttpService } from '../service/http.service';
import { QuotationTemplate } from '../quotation-template';
import { School } from '../school';
import { SchoolListItem } from '../school-list-item';
import { ToastMessageService } from '../toast-message.service';
import { ConfirmationService } from 'primeng/api';


@Component({
  selector: 'app-quotation-templates',
  templateUrl: './quotation-templates.component.html',
  styleUrls: ['./quotation-templates.component.css']
})
export class QuotationTemplatesComponent implements OnInit {

  templates: QuotationTemplate[] = [];
  filteredTemplates: QuotationTemplate[] = [];
  selectedSchool!: School | null;
  schools: SchoolListItem[] = [];

  constructor(
    private httpService: HttpService,
    private toastService: ToastMessageService,
    private confirmationService: ConfirmationService
  ) { }

  ngOnInit(): void {
    this.httpService.getAllQuotationTemplates().subscribe(res => {
      this.templates = res;
      this.filteredTemplates = res;
    }
    );
    this.httpService.getActiveSchools().subscribe(res => {
      this.schools = res;
    });
  }

  filterList() {
    this.filteredTemplates = this.templates.filter(template => template.school.id == this.selectedSchool!.id);
  }

  resetFilter(){
    this.filteredTemplates = this.templates;
    this.selectedSchool = null;
  }

  deteteTemplate(templateId: number){
    this.confirmationService.confirm({
      message: "Do you want to delete the template id: " + templateId + "?",
      accept: () => {
        this.httpService.archiveQuotationTemplate(templateId).subscribe(() => {
          this.removeById(this.templates, templateId);
          this.removeById(this.filteredTemplates, templateId);
          this.toastService.addSuccess("Success", "Template deleted");
        }, error => this.toastService.addError("Error", "Template is not deleted"));
      }
    });
  }

  removeById(templateArray: QuotationTemplate[], templateId: number){
    for(let template of templateArray){
      if(template.id == templateId){
        const index = templateArray.indexOf(template);
        templateArray.splice(index, 1);
      }
    }
  }

}
